import styled from "styled-components";

export const ContentWrapper = styled.section`
  padding: 0px 20px;
  width: 100%;
`;
